const __WEBPACK_NAMESPACE_OBJECT__ = require("@divkitframework/divkit/client-hydratable");